import React from 'react';
import { PaymentElement, ElementsConsumer } from '@stripe/react-stripe-js';
import { buildHeaders, generateUrlApiV2 } from '../../util/helpers/MiddlewareHelpers';
import { useHistory } from 'react-router-dom';

class CheckoutFormInner extends React.Component {

  // constructor(props) {
  //   super(props);
  //   this.handleSubmit = this.handleSubmit.bind(this);
  //   console.log('props-check', props);
  // }

  state = { status: 'idle', message: '', code: null };

  fetchCodeConfirm = async (paymentIntentId) => {
    // return fetch('http://localhost:3000/sandbox/cw-payment/check-payment-get-code', {
    const headers = buildHeaders();
    const url = generateUrlApiV2(`/cw-payment/check-payment-get-code`);
    return fetch(url, {
      method: 'POST',
      headers,
      crossdomain: true,
      body: JSON.stringify({
        paymentIntentId,
        // orderId: this.props.orderId,
        // retrievalToken: this.props.retrievalToken,
      }),
    });
  };

  fetchCodeWithRetries = async (paymentIntentId) => {
    const maxAttempts = 4;
    let attempt = 0;
    let delay = 800;
    while (attempt < maxAttempts) {
      attempt += 1;
      try {
        const res = await this.fetchCodeConfirm(paymentIntentId);
        if (res.status === 200) {
          const body = await res.json();
          return { success: true, code: body.uniqueCode };
        }
        if (res.status === 202) {
          await new Promise((r) => setTimeout(r, delay));
          delay *= 1.8;
          continue;
        }
        const body = await res.json().catch(() => ({}));
        return { success: false, error: body.error || 'Server error' };
      } catch (err) {
        if (attempt >= maxAttempts) return { success: false, error: err.message || 'Network error' };
        await new Promise((r) => setTimeout(r, delay));
        delay *= 1.8;
      }
    }
    return { success: false, error: 'Code not ready' };
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    // this.props.history.push(this.props.location.pathname + '/' + this.props.uuid);
    const { stripe, elements } = this.props;
    if (!stripe || !elements) return;
    this.setState({ status: 'processing', message: '', code: null });

    const { error: confirmError, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {},
      redirect: 'if_required',
    });

    console.log('payment-inte', paymentIntent);
    console.log('payment-error', confirmError);

    if (confirmError) {
      this.setState({ status: 'error', message: confirmError.message || 'Payment confirmation failed.' });
      return;
    }

    if (!paymentIntent) {
      this.setState({ status: 'processing', message: 'Redirecting for authentication…' });
      return;
    }

    if (['succeeded', 'processing', 'requires_capture'].includes(paymentIntent.status)) {
      this.setState({ message: 'Verifying payment with server…' });
      const result = await this.fetchCodeWithRetries(paymentIntent.id);
      if (result.success) {
        localStorage.setItem(`${this.props.compData.id}-orderPaid`, true);
        this.setState({ status: 'succeeded', code: result.code, message: 'Payment succeeded! Your code has been sent to your email. ' });
        const url = new URL(window.location.href);
        url.search = '';
        window.location.href = url.toString() + '/' + this.props.uuid;
      } else {
        this.setState({ status: 'error', message: result.error || 'Payment succeeded but code unavailable.' });
      }
    } else {
      this.setState({ status: 'error', message: `Unexpected payment status: ${paymentIntent.status}` });
    }
  };

  render() {
    const { status, message, code } = this.state;
    const formData = localStorage.getItem(`${this.props.compData.id}-optData`);
    console.log('form-check-new', formData);
    const disabled = status === 'processing';
    return (
      <div>
        {status !== 'succeeded' && <form id="payment-form" onSubmit={this.handleSubmit}>
          <div style={{ marginBottom: 12 }}>
            <PaymentElement />
          </div>
          {/* <button type="submit" disabled={disabled}>
            {status === 'processing' ? 'Processing…' : 'Pay $20.00'}
          </button>*/}

          <button type="submit" disabled={disabled}
            className={"primary submit-optin cursor-pointer green-btn"}
          >
            {status === 'processing' ? 'Processing…' : 'Pay Now'}
          </button>
        </form>}

        <div style={{ marginTop: 16 }}>
          {code && (
            <div style={{ marginTop: 12, padding: 12, border: '1px solid #ddd', display: 'inline-block', background: '#f9f9f9' }}>
              <strong style={{ fontSize: 18 }}>{code}</strong>
            </div>
          )}
          {message && status === 'error' ? <div style={{ color: 'red', marginTop: 8 }}>{message}</div>
            : <div>{message}</div>}
        </div>
      </div>
    );
  }
}

// const WrappedCheckoutFormInner = withRouter(CheckoutFormInner);
// export { WrappedCheckoutFormInner as CheckoutFormInner };

// Wrap using ElementsConsumer to inject stripe and elements props
// export default function CheckoutFormClass(props) {
//   return (
//     <ElementsConsumer>
//       {({ stripe, elements }) => <CheckoutFormInner {...props} stripe={stripe} elements={elements} />}
//     </ElementsConsumer>
//   );
// }
//
export default function CheckoutFormClass(props) {
  const history = useHistory();
  return (
    <ElementsConsumer>
      {({ stripe, elements }) =>
        // Pass stripe and elements down to the wrapped component
        <CheckoutFormInner
          {...props}
          stripe={stripe}
          elements={elements}
          history={history}
        />
      }
    </ElementsConsumer>
  );
}
